import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';

/**
 * 创建 localStorage 持久化器
 * 用于将 TanStack Query 的缓存数据持久化到 localStorage
 */
export const localStoragePersister = createAsyncStoragePersister({
  storage: typeof window !== 'undefined'
    ? {
      getItem: (key) => Promise.resolve(window.localStorage.getItem(key)),
      setItem: (key, value) => Promise.resolve(window.localStorage.setItem(key, value)),
      removeItem: (key) => Promise.resolve(window.localStorage.removeItem(key)),
    }
    : undefined,
  // 可选：设置存储键的前缀，避免与其他数据冲突
  key: 'react-query-cache',
  // 优化：使用更高效的序列化/反序列化函数
  serialize: (data) => {
    try {
      // 使用更紧凑的JSON序列化，减少存储空间
      return JSON.stringify(data, null, 0);
    } catch (error) {
      // 在构建时减少错误日志输出
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to serialize query cache:', error);
      }
      return '{}';
    }
  },
  deserialize: (data) => {
    try {
      return JSON.parse(data);
    } catch (error) {
      // 在构建时减少错误日志输出
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to deserialize query cache:', error);
      }
      return {};
    }
  },
});

/**
 * 创建 sessionStorage 持久化器（可选）
 * 用于临时数据持久化，关闭浏览器标签页后数据会被清除
 */
export const sessionStoragePersister = createAsyncStoragePersister({
  storage: typeof window !== 'undefined'
    ? {
      getItem: (key) => Promise.resolve(window.sessionStorage.getItem(key)),
      setItem: (key, value) => Promise.resolve(window.sessionStorage.setItem(key, value)),
      removeItem: (key) => Promise.resolve(window.sessionStorage.removeItem(key)),
    }
    : undefined,
  key: 'react-query-session-cache',
});

/**
 * 持久化配置选项
 * 优化配置以减少构建时间和运行时开销
 */
export const persistOptions = {
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 12, // 12小时
  maxSize: 5 * 1024 * 1024, // 5MB（提高上限避免频繁清理）
  // 是否在后台重新获取数据
  buster: '', // 可以设置版本号，当版本号改变时清除缓存
  // 注意：throttleTime 可能不是标准的 persistOptions 配置项
  // 如果需要节流，请在 PersistQueryClientProvider 层面实现
};
